import { ListLocationViewModel } from "client/Api/Documents/SharePoint/common";
import { environmentHttpClient } from "client/Api/httpClient";

export interface TeamListItemViewModel {
	id: string;
	displayName: string;
}

export interface TeamDetailsViewModel {
	webUrl: string;
	sharePoint: TeamSiteInformationViewModel;
}

export interface TeamSiteInformationViewModel {
	location: ListLocationViewModel | null;
}

export function listTeams(): Promise<readonly TeamListItemViewModel[]> {
	return environmentHttpClient.get<readonly TeamListItemViewModel[]>(
		"Workspace/LiveInformation/Teams"
	);
}

export function getTeamDetails(id: string): Promise<TeamDetailsViewModel> {
	return environmentHttpClient.get<TeamDetailsViewModel>(
		`Workspace/LiveInformation/Teams/${encodeURIComponent(id)}/Details`
	);
}